// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-200">
      <div className="container mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo & Tagline */}
        <div className="space-y-4">
          <img
            src="/logo3.png"
            alt="FutureYX Logo"
            className="w-50"
          />
          <p className="text-gray-400">
            FutureYX provides secure, scalable, and responsive IT solutions,
            tailored to drive your business forward.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xl font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2">
            {["/", "/services", "/about", "/contact"].map((path) => (
              <li key={path}>
                <Link
                  to={path}
                  className="text-gray-400 hover:text-[#D7631F] transition-colors"
                >
                  {path === "/"
                    ? "Home"
                    : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-xl font-semibold text-white mb-4">Contact Us</h4>
          <ul className="space-y-3 text-gray-400">
            <li className="flex items-center">
              <MapPinIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              6352 LOTUS STREET,<br />
              EASTVALE, CA 92880, US
            </li>
            <li className="flex items-center">
              <PhoneIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              +1 (323) 985-8774
            </li>
            <li className="flex items-center">
              <EnvelopeIcon className="w-5 h-5 mr-2 text-[#D7631F]" />
              <a
                href="mailto:info@futureyx.com"
                className="hover:text-[#D7631F] transition-colors"
              >
                info@futureyx.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-4 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} FutureYX. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
